import React, { useState } from "react";
import { validateObjectByFields } from "../../../../util/validate";
import { useUIContext } from "../../../../context/UIContext";
import { useTranslation } from "react-i18next";

export default function EmptySpecialSubjectContentTr({
  setHideAddBtn,
  setIsAddingRow,
  parentId,
  parentHierarchyLevel,
  items,
  setItems,
  setRows,
}) {
  const { t } = useTranslation();
  const [isSaving, setIsSaving] = useState(false);
  const [validateStyles, setValidateStyles] = useState({});
  const { handleToastCenterTop } = useUIContext();

  // ID 생성 함수 (자동 증가)
  const getNextId = () => {
    if (!Array.isArray(items) || items.length === 0) return 1;
    const maxId = Math.max(...items.map((item) => item.id || 0));
    return maxId + 1;
  };

  const [addNewRow, setAddNewRow] = useState({
    id: getNextId(),
    hierarchy_level: parentHierarchyLevel + 1,
    content: "",
    field: "",
    order: "1",
    parent_id: parentId,
  });

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setAddNewRow((prev) => ({ ...prev, [name]: value }));

    // 입력 요소가 textarea일 경우 높이 자동 조정
    if (type === "textarea") {
      const textarea = e.target;
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const handleCancel = () => {
    setAddNewRow({
      id: 0,
      hierarchy_level: "",
      content: "",
      field: "",
      order: "1",
      parent_id: 0,
    });
    setHideAddBtn(false);
    setIsAddingRow(false);
  };

  const createNewRow = () => {
    const fieldsToValidate = [
      {
        key: "order",
        type: "number",
        required: true,
        name: t("common.labels.order") || "순서",
      },
    ];

    // hierarchy_level 2인 경우 field도 필수
    if (addNewRow.hierarchy_level === 2) {
      fieldsToValidate.push(
        {
          key: "field",
          type: "string",
          required: true,
          name: t("teacher.lessonRelated.area") || "영역",
        },
        {
          key: "content",
          type: "string",
          required: true,
          name: t("teacher.lessonRelated.content") || "내용",
        }
      );
    }

    setValidateStyles({});

    const errorObject = validateObjectByFields(addNewRow, fieldsToValidate);
    const typeErrors = Object.values(errorObject.type || {});
    const requiredErrors = Object.values(errorObject.required || {});
    const allErrors = typeErrors.concat(requiredErrors);
    const errorMessageString = allErrors.join("\n");

    if (allErrors.length > 0) {
      const newStyles = {};
      Object.keys(errorObject.type).forEach((key) => (newStyles[key] = true));
      Object.keys(errorObject.required).forEach(
        (key) => (newStyles[key] = true)
      );
      setValidateStyles(newStyles);
      handleToastCenterTop(errorMessageString);
      return;
    }

    setIsSaving(true);

    // 상태에 추가
    const newItems = [...items, addNewRow].sort((a, b) => {
      // hierarchy_level 우선 정렬
      if (a.hierarchy_level !== b.hierarchy_level) {
        return a.hierarchy_level - b.hierarchy_level;
      }
      // 같은 레벨이면 parent_id로 정렬
      if (a.parent_id !== b.parent_id) {
        return a.parent_id - b.parent_id;
      }
      // 같은 parent_id면 order로 정렬
      const orderA = parseFloat(a.order) || 0;
      const orderB = parseFloat(b.order) || 0;
      return orderA - orderB;
    });

    setItems(newItems);
    setRows(newItems);

    setIsSaving(false);
    setIsAddingRow(false);
    setHideAddBtn(false);
    setAddNewRow({
      id: 0,
      hierarchy_level: "",
      content: "",
      field: "",
      order: "1",
      parent_id: 0,
    });
  };

  return (
    <tr>
      <th scope="row" className="text-center align-middle p-0">
        {addNewRow?.hierarchy_level || ""}
      </th>
      <td
        className="changePaddings pt-0 pb-0 align-middle"
        style={{
          paddingLeft: `${(addNewRow?.hierarchy_level - 1) * 20}px`,
        }}
      >
        <div className="d-flex">
          {addNewRow?.hierarchy_level > 1 && (
            <span
              style={{
                fontSize: "24px",
                color: "gray",
                verticalAlign: "top",
                display: "inline-block",
                lineHeight: "1",
                paddingTop: "0px",
              }}
            >
              ㄴ
            </span>
          )}
          {addNewRow?.hierarchy_level === 1 ? (
            <input
              type="text"
              className="input-like-span ms-2"
              name="field"
              value={addNewRow?.field || ""}
              onChange={handleChange}
              placeholder="최상위"
              required
              style={{
                backgroundColor: validateStyles?.field ? "pink" : undefined,
              }}
            />
          ) : (
            <input
              type="text"
              className="input-like-span ms-2"
              name="field"
              value={addNewRow?.field || ""}
              onChange={handleChange}
              placeholder="영역"
              required
              style={{
                backgroundColor: validateStyles?.field ? "pink" : undefined,
              }}
            />
          )}
        </div>
      </td>
      <td className="text-center align-middle p-0">
        {addNewRow?.hierarchy_level === 2 ? (
          <textarea
            className="input-like-span pt-1 pb-1"
            name="content"
            value={addNewRow?.content || ""}
            onChange={handleChange}
            rows={1}
            required
            style={{
              backgroundColor: validateStyles?.content ? "pink" : undefined,
            }}
          />
        ) : (
          <span className="text-muted" style={{ fontSize: "0.8rem" }}>
            최상위 영역 미사용시 빈칸으로 저장 후 아래에 영역 추가 가능
          </span>
        )}
      </td>
      <td className="text-center align-middle p-0">
        <input
          type="number"
          className="input-like-span ms-2"
          value={addNewRow?.order || ""}
          name="order"
          onChange={handleChange}
          required
          style={{
            backgroundColor: validateStyles?.order ? "pink" : undefined,
          }}
        />
      </td>
      <td className="text-center align-middle p-0 m-0"></td>
      <td className="text-center align-middle p-0">
        <button
          type="button"
          onClick={handleCancel}
          className="btn btn-sm btn-secondary"
        >
          {t("common.labels.cancel") || "취소"}
        </button>

        {isSaving ? (
          <button className="btn btn-sm btn-primary ms-1" disabled>
            {t("common.status.adding") || "추가중"}..
          </button>
        ) : (
          <button
            type="button"
            onClick={createNewRow}
            className="btn btn-sm btn-primary ms-1"
          >
            {t("common.labels.add") || "추가"}
          </button>
        )}
      </td>
    </tr>
  );
}
